import { AuthState } from "ram-components";
import { ref } from "vue";

const authState = ref<AuthState>({} as AuthState);

function handleStorageEvent() {
  const _authState = localStorage.getItem("authState");
  if (_authState) {
    authState.value = JSON.parse(_authState);
  } else {
    authState.value = {} as AuthState;
  }
}

function setAuthState(_state: AuthState) {
  authState.value = _state;
  localStorage.setItem("authState", JSON.stringify(_state));
}

export function useAuthState() {
  window.addEventListener("storage", handleStorageEvent);
  handleStorageEvent();
  return { authState, setAuthState };
}
